import React from 'react';
import PrenotaOra from '../prenotaOra';

/**
 * Wrapper component that automatically applies 'call-to-action' class
 * and includes PrenotaOra component
 */
const CallToActionWrapper = ({ 
  text, 
  children,
  className = '',
  tag: Tag = 'div'
}) => {
  const classes = ['call-to-action'];
  
  if (className) {
    classes.push(className);
  }

  return (
    <Tag className={classes.join(' ')}>
      {children || <PrenotaOra text={text} />}
    </Tag>
  );
};

export default CallToActionWrapper;